import React from 'react';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { connect } from 'react-redux';
import { changesNotificationModalActions } from '../../behavior/changesNotificationModal';
import { genericDetailsActions } from '../../behavior/genericDetails';
import UserDateInformationContentContainer from './UserDateInformationContentContainer';

type Props = {
  columns?: number;
  closable?: boolean;
  renderDefaultButtons?: boolean;
  initialData: { currentUser: any };
  userName: string;
  setFieldValue: (name: string, value: any) => void;
  userLabel?: string;
  dteLabel?: string;
  dteName?: string;
  setMarkAsChecked: () => void;
  toggleValidationMessage: () => void;
  renderOther?: (props: Props) => void;
  openDirection?: string;
  isInventory?: boolean;
  setValidateOnChange: (value: boolean) => void;
  formikProps?: any;
  accordionTooltip?: string;
  values: any;
  errors?: any;
  showPersonalData?: boolean;
  disabled: boolean;
  accordionTitle?: string;
  id?: string;
};

const UserDateInformationContainer: React.FC<Props> = props => {
  return (
    <AccordionWrapper
      {...props}
      tooltip={props.accordionTooltip}
      closable={props.closable}
      className="containerReducedWhiteSpace"
      render={() => <UserDateInformationContentContainer {...props} />}
    />
  );
};

UserDateInformationContainer.defaultProps = {
  closable: true,
  columns: 3,
  renderDefaultButtons: true,
};

const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
  processedNotificationBody: state.changesNotificationModal.processedChangesNotification,
  recipients: state.changesNotificationModal.recipients,
  markAsChecked: state.changesNotificationModal.markAsChecked,
  toggleValidationMessage: state.genericDetails.toggleValidationMessage,
});

const mapDispatchToProps = (dispatch: any) => ({
  toggleValidationMessage: () => dispatch(genericDetailsActions.toggleValidationMessage()),
  setMarkAsChecked: () => dispatch(changesNotificationModalActions.setMarkAsChecked(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDateInformationContainer);
